<template>
  <div class="next-screen" :class="[{ fadeOutBtn: out }]">
    <v-btn @click="nextScreen" color="primary">
      <div class="icon">
        <img src="@/assets/img/icon/arrow_down_w.svg" />
      </div>
      往下更多商品
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NextScreen',
  props: {
    isScrolled: {
      type: Boolean,
      default: false,
    },
    isScrolling: {
      type: Boolean,
      default: false,
    },
    contentH: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      viewH: 0,
    }
  },
  methods: {
    nextScreen() {
      window.scrollTo({
        top: this.viewH,
        behavior: 'smooth',
      })
    },
  },
  computed: {
    out() {
      return this.isScrolled || this.viewH >= this.contentH
    },
  },
  created() {
    this.viewH = window.screen.height
  },
}
</script>

<style scoped lang="scss">
.next-screen {
  position: fixed;
  bottom: 20px;
  width: 100%;
  text-align: center;
  transition: bottom 0.3s;
  z-index: 2;
  &.fadeOutBtn {
    bottom: -100px;
  }
  .icon {
    width: 17px;
    height: 17px;
    margin-right: 9px;
    img {
      width: 100%;
    }
  }
  .v-btn {
    height: 40px !important;
    font-size: 15px;
    border-radius: 40px !important;
    padding: 0 13px !important;
    letter-spacing: normal;
    .v-btn__content {
      align-items: center;
    }
  }
}
</style>
